module.exports = __webpack_public_path__ + "static/media/YandexPay.584d27ef.svg";